<template>
  <Modal :id="id" :modalTitle="modalTitle" :class="classes">
    <form autocomplete="off" id="clientEditForm">
      <div v-if="clientData">
        <!-- Sección de White List y Categorías - Solo para roles específicos -->
        <div class="row">
          <div class="col-3 mb-3 mt-1">
            <div
              class="generalTitleItemModal"
              v-if="!$store.state.roles.Backoffice_member_empresas"
            >
              Nombre
            </div>
            <div
              class="generalTitleItemModal"
              v-if="$store.state.roles.Backoffice_member_empresas"
            >
              Nombre de la compañía
            </div>
            <div>{{ clientData.name || "-" }}</div>
          </div>
          <div
            class="col-3 mb-3 mt-1"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <div class="generalTitleItemModal">Apellido1</div>
            <div>{{ clientData.surnames || "-" }}</div>
          </div>
          <div
            class="col-3 mb-3 mt-1"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <label class="generalTitleItemModal" for="telephone"
              >Teléfono</label
            >
            <input
              type="text"
              id="telephone"
              class="form-control generalInput"
              maxlength="9"
              v-model.trim="telephone"
            />
          </div>
          <div
            v-if="!$store.state.roles.Backoffice_member_empresas"
            class="col-3 mb-3 mt-1"
          >
            <label class="generalTitleItemModal" for="mobile">Móvil</label>
            <input
              type="text"
              id="mobile"
              class="form-control generalInput"
              maxlength="9"
              v-model.trim="mobile"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">Tipo de doc</div>
            <div v-if="!$store.state.roles.Backoffice_member_empresas">DNI</div>
            <div v-if="$store.state.roles.Backoffice_member_empresas">CIF</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div
              class="generalTitleItemModal"
              v-if="!$store.state.roles.Backoffice_member_empresas"
            >
              Número de documento
            </div>
            <div
              class="generalTitleItemModal"
              v-if="$store.state.roles.Backoffice_member_empresas"
            >
              CIF
            </div>
            <div>{{ clientData.legalIdentifier || "-" }}</div>
          </div>
          <div
            class="col-3 mb-3 mt-1"
            v-if="$store.state.roles.Backoffice_member_empresas"
          >
            <div class="generalTitleItemModal">CNAE</div>
            <div>{{ clientData.cname || "-" }}</div>
          </div>
          <div
            class="col-3 mb-3 mt-1"
            v-if="!$store.state.roles.Backoffice_member_empresas"
          >
            <div class="generalTitleItemModal">Fecha de nacimiento</div>
            <div>{{ $dateBackToFront(clientData.birthdate) }}</div>
          </div>
          <div
            class="col-3 mb-3 mt-1"
            v-if="$store.state.roles.Backoffice_member_empresas"
          >
            <label class="generalTitleItemModal" for="employeesNum"
              >Nº Empleados</label
            >
            <input
              id="employeesNum"
              class="form-control generalInput"
              maxlength="9"
              v-model.number="employeesNum"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="email">Email</label>
            <input
              type="text"
              id="email"
              class="form-control generalInput"
              v-model.trim="email"
            />
          </div>
          <!-- Sección White List y Categoría de Crédito -->
          <div class="col-3 mb-3 mt-1">
            <!-- Para usuarios que pueden editar -->
            <div v-if="canManageWhiteListAndCategories" class="custom-control custom-checkbox">
              <input
                type="checkbox"
                class="custom-control-input"
                id="trustworthy"
                v-model.trim="trustworthy"
              />
              <label
                class="custom-control-label labelCheck pb-4"
                for="trustworthy"
                >Añadir cliente a la White List</label
              >
            </div>
            <!-- Para usuarios empresa (solo lectura) -->
            <div v-else>
              <div class="generalTitleItemModal">White List</div>
              <div>{{ trustworthy ? 'Sí' : 'No' }}</div>
            </div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <!-- Para usuarios que pueden editar -->
            <div v-if="canManageWhiteListAndCategories">
              <label for="categoryRating">Categoría de Crédito:</label>
              <select
                id="categoryRating"
                class="form-control"
                v-model="categoryRating"
                required
              >
                <option
                  v-for="category in filteredCategories"
                  :key="category.category"
                  :value="category.category"
                >
                  {{ category.category }} - Saldo disponible:
                  {{ category.availableBuyBalance }}€
                </option>
              </select>
            </div>
            <!-- Para usuarios empresa (solo lectura) -->
            <div v-else>
              <div class="generalTitleItemModal">Categoría de Crédito</div>
              <div>{{ categoryRating || '-' }}</div>
            </div>
          </div>
          <!-- Fin de la sección -->
        </div>
      </div>
      <!-- Sección DATOS EMPRESA - Solo para clientes particulares (no empresas) -->
      <div v-if="clientData && !$store.state.roles.Backoffice_member_empresas">
        <div class="mt-5">
          DATOS EMPRESA
          <hr />
        </div>
        <p class="text-muted small mb-3">
          Complete estos datos si desea que las facturas se emitan a nombre de una empresa en lugar del cliente particular.
        </p>
        <div class="row">
          <div class="col-6 mb-3 mt-1">
            <label class="generalTitleItemModal" for="companyName">Razón Social</label>
            <input
              type="text"
              id="companyName"
              class="form-control generalInput"
              v-model.trim="companyName"
              placeholder="Nombre de la empresa"
            />
          </div>
          <div class="col-6 mb-3 mt-1">
            <label class="generalTitleItemModal" for="companyCIF">CIF</label>
            <input
              type="text"
              id="companyCIF"
              class="form-control generalInput"
              v-model.trim="companyCIF"
              placeholder="Ej: B12345678"
              maxlength="9"
            />
          </div>
        </div>
      </div>
      <div v-if="clientData.deliveryAddress">
        <div class="mt-5" v-if="!$store.state.roles.Backoffice_member_empresas">
          DIRECCIÓN
          <hr />
        </div>
        <div class="mt-5" v-if="$store.state.roles.Backoffice_member_empresas">
          DIRECCIÓN DE LA COMPAÑÍA
          <hr />
        </div>
        <div class="row">
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="direccion"
              >Dirección</label
            >
            <input
              type="text"
              id="direccion"
              class="form-control generalInput"
              v-model.trim="deliveryAddressStreet"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="numero">Número</label>
            <input
              type="text"
              id="numero"
              class="form-control generalInput"
              v-model.trim="deliveryAddressNumber"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="localidad"
              >Localidad</label
            >
            <input
              type="text"
              id="localidad"
              class="form-control generalInput"
              v-model.trim="deliveryAddressCity"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="state">Provincia</label>
            <VueNextSelect
              class="form-control generalInput"
              id="state"
              :options="provincesData"
              v-model.trim="deliveryAddressProvince"
              placeholder=""
              close-on-select
            ></VueNextSelect>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">País</div>
            <div>España</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="postalCode"
              >Código postal</label
            >
            <input
              type="text"
              id="postalCode"
              class="form-control generalInput"
              v-model.trim="deliveryAddressPostalCode"
            />
          </div>
        </div>
      </div>
      <div v-if="clientData.billingAddress">
        <div class="mt-5">
          DIRECCIÓN DE FACTURACIÓN DE LA COMPAÑIA
          <hr />
        </div>
        <div class="row">
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="direccion"
              >Dirección</label
            >
            <input
              type="text"
              id="direccion"
              class="form-control generalInput"
              v-model.trim="billingAddressStreet"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="numero">Número</label>
            <input
              type="text"
              id="numero"
              class="form-control generalInput"
              v-model.trim="billingAddressNumber"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="localidad"
              >Localidad</label
            >
            <input
              type="text"
              id="localidad"
              class="form-control generalInput"
              v-model.trim="billingAddressCity"
            />
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="state">Provincia</label>
            <VueNextSelect
              class="form-control generalInput"
              id="state"
              :options="provincesData"
              v-model.trim="billingAddressProvince"
              placeholder=""
              close-on-select
            ></VueNextSelect>
          </div>
          <div class="col-3 mb-3 mt-1">
            <div class="generalTitleItemModal">País</div>
            <div>España</div>
          </div>
          <div class="col-3 mb-3 mt-1">
            <label class="generalTitleItemModal" for="postalCode"
              >Código postal</label
            >
            <input
              type="text"
              id="postalCode"
              class="form-control generalInput"
              v-model.trim="billingAddressPostalCode"
            />
          </div>
        </div>
        <div v-if="$store.state.roles.Backoffice_member_empresas">
          <div class="mt-5">
            AUTORIZADO 1
            <hr />
          </div>
          <div class="row">
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="nombreAutorizado1"
                >Nombre</label
              >
              <input
                type="text"
                id="nombreAutorizado1"
                class="form-control generalInput"
                v-model.trim="authorized1Name"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="telefonoAutorizado1"
                >Teléfono</label
              >
              <input
                type="text"
                id="telefonoAutorizado1"
                class="form-control generalInput"
                v-model.trim="authorized1Phone"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="emailAutorizado1"
                >Email</label
              >
              <input
                type="text"
                id="emailAutorizado1"
                class="form-control generalInput"
                v-model.trim="authorized1Email"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="dniAutorizado1"
                >DNI</label
              >
              <input
                type="text"
                id="dniAutorizado1"
                class="form-control generalInput"
                v-model.trim="authorized1DNI"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="powerAutorizado1"
                >Poder</label
              >
              <VueNextSelect
                class="form-control generalInput"
                id="powerAutorizado1"
                :options="power"
                v-model="authorized1Power"
                placeholder=""
                close-on-select
              ></VueNextSelect>
            </div>
          </div>
        </div>
        <div
          v-if="
            $store.state.roles.Backoffice_member_empresas &&
            checkSecondAuth(this.secondAuth)
          "
        >
          <div class="mt-5">
            AUTORIZADO 2
            <hr />
          </div>
          <div class="row">
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="nombreAutorizado2"
                >Nombre</label
              >
              <input
                type="text"
                id="nombreAutorizado2"
                class="form-control generalInput"
                v-model.trim="authorized2Name"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="telefonoAutorizado2"
                >Teléfono</label
              >
              <input
                type="text"
                id="telefonoAutorizado2"
                class="form-control generalInput"
                v-model.trim="authorized2Phone"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="emailAutorizado2"
                >Email</label
              >
              <input
                type="text"
                id="emailAutorizado2"
                class="form-control generalInput"
                v-model.trim="authorized2Email"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="dniAutorizado2"
                >DNI</label
              >
              <input
                type="text"
                id="dniAutorizado2"
                class="form-control generalInput"
                v-model.trim="authorized2DNI"
              />
            </div>
            <div class="col-3 mb-3 mt-1">
              <label class="generalTitleItemModal" for="powerAutorizado2"
                >Poder</label
              >
              <VueNextSelect
                class="form-control generalInput"
                id="powerAutorizado2"
                :options="power"
                v-model="authorized2Power"
                placeholder=""
                close-on-select
              ></VueNextSelect>
            </div>
          </div>
        </div>
      </div>
      <div
        class="h-100 d-flex align-items-center mt-3"
        v-bind:class="{
          'justify-content-end': !$store.state.roles.Backoffice_member_empresas,
          'justify-content-between':
            $store.state.roles.Backoffice_member_empresas,
        }"
      >
        <a
          href="#"
          class="mb-2"
          @click="secondAuth = true"
          v-if="
            $store.state.roles.Backoffice_member_empresas &&
            !checkSecondAuth(this.secondAuth)
          "
        >
          <v-icon name="hi-plus" scale="1.1" />
          Añadir nuevo autorizado
        </a>

        <a
          href="#"
          class="mb-2"
          @click="secondAuth = false"
          v-if="
            $store.state.roles.Backoffice_member_empresas &&
            checkSecondAuth(this.secondAuth)
          "
        >
          <v-icon name="hi-minus" scale="1.1" />
          Quitar autorizado
        </a>

        <button
          id="submitButton"
          class="btn btn-primary generalPrimaryButton mb-0"
          @click="updateClientData()"
          :disabled="!canSave || isUpdating"
          type="button"
        >
          <span v-if="isUpdating">Guardando...</span>
          <span v-else>Guardar</span>
        </button>
      </div>
    </form>
  </Modal>

  <div class="response-message-container">
    <transition name="fade">
      <div v-if="showSuccessMessage" class="success-message">
        <span>¡Datos editados correctamente!</span>
      </div>
      <div v-else-if="showErrorMessage" class="error-message">
        <span>Error al editar datos: {{ errorMessage }}</span>
      </div>
    </transition>
  </div>
</template>

<script>
import Modal from "../../../Shared/Modal.vue";
import axios from "axios";
import VueNextSelect from "vue-next-select";
import provincias from "../../../../../data/provinces.json";
import useVuelidate from "@vuelidate/core";
import { Modal as ModalBootstrap } from "bootstrap";

export default {
  name: "ClientDetail",
  props: ["id", "modalTitle", "class", "clientDni"],
  data() {
    return {
      classes: this.class,
      permission: "",
      clientData: "",
      provincesData: provincias,
      trustworthy: false,
      categoryRating: "",
      categories: [],
      telephone: "",
      mobile: "",
      email: "",
      deliveryAddressStreet: "",
      deliveryAddressNumber: "",
      deliveryAddressPostalCode: "",
      deliveryAddressCity: "",
      deliveryAddressProvince: "",
      billingAddressStreet: "",
      billingAddressNumber: "",
      billingAddressPostalCode: "",
      billingAddressCity: "",
      billingAddressProvince: "",
      authorized1Name: "",
      authorized1Phone: "",
      authorized1Email: "",
      authorized1DNI: "",
      authorized1Power: "",
      authorized2Name: "",
      authorized2Phone: "",
      authorized2Email: "",
      authorized2DNI: "",
      authorized2Power: "",
      power: [true, false],
      powerSelected: false,
      employeesNum: 0,
      secondAuth: false,
      // Datos empresa para facturación
      companyName: "",
      companyCIF: "",
      showSuccessMessage: false,
      showErrorMessage: false,
      errorMessage: null,
      isUpdating: false,
      isLoading: false,
      // Datos originales para detectar cambios
      originalData: {
        telephone: "",
        mobile: "",
        email: "",
        employeesNum: 0,
        deliveryAddressStreet: "",
        deliveryAddressNumber: "",
        deliveryAddressPostalCode: "",
        deliveryAddressCity: "",
        deliveryAddressProvince: "",
        billingAddressStreet: "",
        billingAddressNumber: "",
        billingAddressPostalCode: "",
        billingAddressCity: "",
        billingAddressProvince: "",
        authorized1Name: "",
        authorized1Phone: "",
        authorized1Email: "",
        authorized1DNI: "",
        authorized1Power: "",
        authorized2Name: "",
        authorized2Phone: "",
        authorized2Email: "",
        authorized2DNI: "",
        authorized2Power: "",
        // Datos empresa para facturación
        companyName: "",
        companyCIF: "",
      },
    };
  },
  validations() {
    return {
      categoryRating: {
        requiredIfTrustworthy: (value) => {
          // Solo es requerido si trustworthy está marcado
          return !this.trustworthy || (this.trustworthy && value);
        },
      },
      trustworthy: {
        requiredIfCategory: (value) => {
          // Solo es requerido si hay una categoría seleccionada
          return !this.categoryRating || (this.categoryRating && value);
        },
      },
    };
  },

  computed: {
    // Computed property para determinar si el usuario puede gestionar White List y categorías
    canManageWhiteListAndCategories() {
      // Los roles Admin o SuperAdmin pueden gestionar White List y categorías
      // independientemente de si son usuarios empresa o no
      return (
        this.$store.state.roles.admin ||
        this.$store.state.roles.super_admin ||
        this.$store.state.roles.Backoffice_admin ||
        this.$store.state.roles.Backoffice_Superadmin
      );
    },
    filteredCategories() {
      if (this.$store.state.roles.Backoffice_Superadmin) {
        return this.categories;
      }
      return this.categories.filter(c => c.category !== 'TOP');
    },

    hasDataChanges() {
      // Comparar datos actuales con originales
      const currentData = {
        telephone: this.telephone || "",
        mobile: this.mobile || "",
        email: this.email || "",
        employeesNum: this.employeesNum || 0,
        deliveryAddressStreet: this.deliveryAddressStreet || "",
        deliveryAddressNumber: this.deliveryAddressNumber || "",
        deliveryAddressPostalCode: this.deliveryAddressPostalCode || "",
        deliveryAddressCity: this.deliveryAddressCity || "",
        deliveryAddressProvince: this.deliveryAddressProvince || "",
        billingAddressStreet: this.billingAddressStreet || "",
        billingAddressNumber: this.billingAddressNumber || "",
        billingAddressPostalCode: this.billingAddressPostalCode || "",
        billingAddressCity: this.billingAddressCity || "",
        billingAddressProvince: this.billingAddressProvince || "",
        authorized1Name: this.authorized1Name || "",
        authorized1Phone: this.authorized1Phone || "",
        authorized1Email: this.authorized1Email || "",
        authorized1DNI: this.authorized1DNI || "",
        authorized1Power: this.authorized1Power || "",
        authorized2Name: this.authorized2Name || "",
        authorized2Phone: this.authorized2Phone || "",
        authorized2Email: this.authorized2Email || "",
        authorized2DNI: this.authorized2DNI || "",
        authorized2Power: this.authorized2Power || "",
        // Datos empresa para facturación
        companyName: this.companyName || "",
        companyCIF: this.companyCIF || "",
      };

      // Verificar si hay cambios en algún campo
      for (const key in currentData) {
        if (currentData[key] !== this.originalData[key]) {
          return true;
        }
      }
      return false;
    },

    isWhiteListAndCategoryValid() {
      // Solo validar si el usuario puede gestionar White List y categorías
      if (!this.canManageWhiteListAndCategories) {
        return true; // Si no puede gestionarlas, siempre es válido
      }
      
      // Validar la lógica condicional de WL y categoría
      if (this.trustworthy && !this.categoryRating) {
        return false; // Si está en WL pero no tiene categoría
      }
      if (this.categoryRating && !this.trustworthy) {
        return false; // Si tiene categoría pero no está en WL
      }
      return true; // Ambos están vacíos o ambos están llenos
    },

    canSave() {
      // El botón se habilita si:
      // 1. Hay cambios en los datos del cliente (siempre permitido)
      if (this.hasDataChanges) {
        return true;
      }

      // 2. Si puede gestionar WL y categorías Y está configurándolas
      if (this.canManageWhiteListAndCategories && (this.trustworthy || this.categoryRating)) {
        return this.isWhiteListAndCategoryValid;
      }

      return false;
    },
  },

  created() {
    this.loadCreditCategories();
  },
  mounted() {
    this.loadClientData();
  },
  watch: {
    clientDni: {
      handler(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          this.loadClientData();
        }
      },
      immediate: false,
    },
  },
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    Modal,
    VueNextSelect,
  },
  methods: {
    loadCreditCategories() {
      axios
        .get("/rating-info/search")
        .then((response) => {
          this.categories = response.data;
        })
        .catch((error) => console.error("Error loading categories:", error));
    },
    showSuccess() {
      this.showSuccessMessage = true;
      setTimeout(() => {
        this.showSuccessMessage = false;
      }, 3000); // Hide message after 3 seconds
    },
    showError(message) {
      this.showErrorMessage = true;
      this.errorMessage = message;
      setTimeout(() => {
        this.showErrorMessage = false;
        this.errorMessage = null;
      }, 3000);
    },
    async loadClientData() {
      if (!this.clientDni) return;

      this.isLoading = true;
      try {
        let urlClientes = "/customer/";
        if (this.$store.state.roles.Backoffice_member_empresas) {
          urlClientes = "/business" + urlClientes + "get/";
        }

        const response = await axios.get(urlClientes + this.clientDni);
        const data = response.data;

        // Asignar datos básicos del cliente
        this.clientData = data;
        
        // Siempre cargar datos de White List y categorías para mostrarlos
        // pero solo permitir edición si el usuario tiene permisos
        this.trustworthy =
          data.trustworthy !== undefined ? data.trustworthy : false;
        this.categoryRating =
          (this.trustworthy &&
            data.creditCategory &&
            data.creditCategory.whitelist) ||
          "";
        this.mobile = data.mobile;
        this.telephone = data.telephone;
        this.email = data.email;

        // Cargar datos de empresa para facturación (solo para clientes particulares)
        // TODO: Verificar nombres de campos del endpoint cuando esté disponible
        this.companyName = data.companyName || data.billingCompanyName || "";
        this.companyCIF = data.companyCIF || data.billingCompanyCIF || "";

        // Guardar datos originales para detectar cambios
        this.originalData.telephone = data.telephone || "";
        this.originalData.mobile = data.mobile || "";
        this.originalData.email = data.email || "";
        this.originalData.companyName = this.companyName;
        this.originalData.companyCIF = this.companyCIF;

        // Procesar direcciones y contactos
        if (data.deliveryAddress !== null) {
          // Dirección de entrega
          // Dirección de entrega
          this.deliveryAddressStreet = data.deliveryAddress.street;
          this.deliveryAddressNumber = data.deliveryAddress.number;
          this.deliveryAddressPostalCode = data.deliveryAddress.postalCode;
          this.deliveryAddressCity = data.deliveryAddress.city;
          this.deliveryAddressProvince = data.deliveryAddress.province;

          // Dirección de facturación
          this.billingAddressStreet = data.billingAddress.street;
          this.billingAddressNumber = data.billingAddress.number;
          this.billingAddressPostalCode = data.billingAddress.postalCode;
          this.billingAddressCity = data.billingAddress.city;
          this.billingAddressProvince = data.billingAddress.province;

          // Guardar datos originales de direcciones
          this.originalData.deliveryAddressStreet =
            data.deliveryAddress.street || "";
          this.originalData.deliveryAddressNumber =
            data.deliveryAddress.number || "";
          this.originalData.deliveryAddressPostalCode =
            data.deliveryAddress.postalCode || "";
          this.originalData.deliveryAddressCity =
            data.deliveryAddress.city || "";
          this.originalData.deliveryAddressProvince =
            data.deliveryAddress.province || "";
          this.originalData.billingAddressStreet =
            data.billingAddress.street || "";
          this.originalData.billingAddressNumber =
            data.billingAddress.number || "";
          this.originalData.billingAddressPostalCode =
            data.billingAddress.postalCode || "";
          this.originalData.billingAddressCity = data.billingAddress.city || "";
          this.originalData.billingAddressProvince =
            data.billingAddress.province || "";

          this.secondAuth = false;

          // Número de empleados
          // Número de empleados
          if (
            data.numberEmployees !== undefined &&
            data.numberEmployees !== null
          ) {
            this.employeesNum = data.numberEmployees;
          } else {
            this.employeesNum = 0;
          }
          this.originalData.employeesNum = this.employeesNum;

          // Contactos de empresa
          if (
            data.companyContact !== undefined &&
            data.companyContact !== null
          ) {
            this.authorized1Name = data.companyContact[0]
              ? data.companyContact[0].name
              : "";
            this.authorized1Phone = data.companyContact[0]
              ? data.companyContact[0].mobile
              : "";
            this.authorized1Email = data.companyContact[0]
              ? data.companyContact[0].email
              : "";
            this.authorized1DNI = data.companyContact[0]
              ? data.companyContact[0].legalIdentifier
              : "";
            this.authorized1Power = data.companyContact[0]
              ? data.companyContact[0].powers
              : "";

            if (data.companyContact[1] !== undefined) {
              this.authorized2Name = data.companyContact[1].name;
              this.authorized2Phone = data.companyContact[1].mobile;
              this.authorized2Email = data.companyContact[1].email;
              this.authorized2DNI = data.companyContact[1].legalIdentifier;
              this.authorized2Power = data.companyContact[1].powers;
              this.secondAuth = true;
            }
          }

          // Guardar datos originales de contactos autorizados
          this.originalData.authorized1Name = this.authorized1Name || "";
          this.originalData.authorized1Phone = this.authorized1Phone || "";
          this.originalData.authorized1Email = this.authorized1Email || "";
          this.originalData.authorized1DNI = this.authorized1DNI || "";
          this.originalData.authorized1Power = this.authorized1Power || "";
          this.originalData.authorized2Name = this.authorized2Name || "";
          this.originalData.authorized2Phone = this.authorized2Phone || "";
          this.originalData.authorized2Email = this.authorized2Email || "";
          this.originalData.authorized2DNI = this.authorized2DNI || "";
          this.originalData.authorized2Power = this.authorized2Power || "";
        } else {
          // Inicializar direcciones vacías
          this.clientData.billingAddress = {
            street: "",
            number: "",
            postalCode: "",
            city: "",
            province: "",
          };
          this.clientData.deliveryAddress = {
            street: "",
            number: "",
            postalCode: "",
            city: "",
            province: "",
          };
          this.deleteData();
        }
      } catch (error) {
        console.error("Error loading client data:", error);
        this.showError("Error al cargar los datos del cliente");
      } finally {
        this.isLoading = false;
      }
    },

    deleteData() {
      this.deliveryAddressStreet = "";
      this.deliveryAddressNumber = "";
      this.deliveryAddressPostalCode = "";
      this.deliveryAddressCity = "";
      this.deliveryAddressProvince = "";
      this.billingAddressStreet = "";
      this.billingAddressNumber = "";
      this.billingAddressPostalCode = "";
      this.billingAddressCity = "";
      this.billingAddressProvince = "";
      this.employeesNum = 0;
      this.authorized1Name = "";
      this.authorized1Phone = "";
      this.authorized1Email = "";
      this.authorized1DNI = "";
      this.authorized1Power = "";
      this.authorized2Name = "";
      this.authorized2Phone = "";
      this.authorized2Email = "";
      this.authorized2DNI = "";
      this.authorized2Power = "";
      // Datos empresa para facturación
      this.companyName = "";
      this.companyCIF = "";

      // Limpiar también los datos originales
      this.originalData.deliveryAddressStreet = "";
      this.originalData.deliveryAddressNumber = "";
      this.originalData.deliveryAddressPostalCode = "";
      this.originalData.deliveryAddressCity = "";
      this.originalData.deliveryAddressProvince = "";
      this.originalData.billingAddressStreet = "";
      this.originalData.billingAddressNumber = "";
      this.originalData.billingAddressPostalCode = "";
      this.originalData.billingAddressCity = "";
      this.originalData.billingAddressProvince = "";
      this.originalData.employeesNum = 0;
      this.originalData.authorized1Name = "";
      this.originalData.authorized1Phone = "";
      this.originalData.authorized1Email = "";
      this.originalData.authorized1DNI = "";
      this.originalData.authorized1Power = "";
      this.originalData.authorized2Name = "";
      this.originalData.authorized2Phone = "";
      this.originalData.authorized2Email = "";
      this.originalData.authorized2DNI = "";
      this.originalData.authorized2Power = "";
      // Datos empresa para facturación
      this.originalData.companyName = "";
      this.originalData.companyCIF = "";
    },
    async updateClientData() {
      // Validar lógica personalizada solo si puede gestionar White List y categorías
      if (this.canManageWhiteListAndCategories && !this.isWhiteListAndCategoryValid) {
        if (this.trustworthy && !this.categoryRating) {
          this.showError("Debe seleccionar una categoría si marca White List");
          return;
        }
        if (this.categoryRating && !this.trustworthy) {
          this.showError("Debe marcar White List si seleccionar una categoría");
          return;
        }
      }

      const bodyToSend = this.buildRequestBody();

      // Deshabilitar botón durante la actualización
      this.isUpdating = true;

      try {
        let whitelistResponse = {};
        
        // Solo actualizar whitelist si el usuario tiene permisos
        if (this.canManageWhiteListAndCategories) {
          whitelistResponse = await this.updateWhitelist(bodyToSend);
        }

        // Siempre actualizar información de contacto (permitido para todos los roles)
        const contactResponse = await this.updateContactInfo(bodyToSend);

        // Actualizar clientData con las respuestas del servidor
        this.clientData = {
          ...this.clientData,
          ...whitelistResponse,
          ...contactResponse,
        };

        // Actualizar datos originales con los nuevos datos guardados
        this.updateOriginalData();

        // Emitir evento para actualizar la lista padre
        this.$emit("refreshParentList", this.clientData);

        // Mostrar mensaje de éxito
        this.showSuccess();

        // Cerrar el modal después de un breve delay para que se vea el mensaje
        setTimeout(() => {
          this.closeModal();
        }, 2000);
      } catch (error) {
        console.error("Error updating client data:", error);
        this.showError(
          error.message || "Error al actualizar los datos del cliente"
        );
      } finally {
        this.isUpdating = false;
      }
    },

    async updateWhitelist(bodyToSend) {
      const urlWhitelist = "/customer/update-whitelist/" + this.clientDni;
      const response = await axios.patch(urlWhitelist, bodyToSend);
      return response.data;
    },

    async updateContactInfo(bodyToSend) {
      let urlContactInfo =
        "/customer/contact-info-by-legal-identifier/" + this.clientDni;
      if (this.$store.state.roles.Backoffice_member_empresas) {
        urlContactInfo = "/business/update-info/" + this.clientDni;
      }
      const response = await axios.patch(urlContactInfo, bodyToSend);
      return response.data;
    },

    buildRequestBody() {
      let bodyToSend;

      if (this.$store.state.roles.Backoffice_member_empresas) {
        // Si tiene dos autorizados
        if (this.secondAuth === true) {
          bodyToSend = {
            email: this.email ? this.email : "",
            numberEmployees: this.employeesNum ? this.employeesNum : 0,
            billingAddress: {
              street: this.billingAddressStreet
                ? this.billingAddressStreet
                : "",
              number: this.billingAddressNumber
                ? this.billingAddressNumber
                : "",
              postalCode: this.billingAddressPostalCode
                ? this.billingAddressPostalCode
                : "",
              city: this.billingAddressCity ? this.billingAddressCity : "",
              province: this.billingAddressProvince
                ? this.billingAddressProvince
                : "",
            },
            deliveryAddress: {
              street: this.deliveryAddressStreet
                ? this.deliveryAddressStreet
                : "",
              number: this.deliveryAddressNumber
                ? this.deliveryAddressNumber
                : "",
              postalCode: this.deliveryAddressPostalCode
                ? this.deliveryAddressPostalCode
                : "",
              city: this.deliveryAddressCity ? this.deliveryAddressCity : "",
              province: this.deliveryAddressProvince
                ? this.deliveryAddressProvince
                : "",
            },
            // Solo incluir trustworthy y categoryRating si el usuario puede gestionarlas
            ...(this.canManageWhiteListAndCategories && {
              trustworthy: this.trustworthy,
              categoryRating: this.categoryRating,
            }),
            companyContact: [
              {
                name: this.authorized1Name ? this.authorized1Name : "",
                mobile: this.authorized1Phone ? this.authorized1Phone : "",
                email: this.authorized1Email ? this.authorized1Email : "",
                powers:
                  this.authorized1Power !== undefined
                    ? this.authorized1Power
                    : "",
                legalIdentifier: this.authorized1DNI ? this.authorized1DNI : "",
              },
              {
                name: this.authorized2Name ? this.authorized2Name : "",
                mobile: this.authorized2Phone ? this.authorized2Phone : "",
                email: this.authorized2Email ? this.authorized2Email : "",
                powers:
                  this.authorized2Power !== undefined
                    ? this.authorized2Power
                    : "",
                legalIdentifier: this.authorized2DNI ? this.authorized2DNI : "",
              },
            ],
          };
        } else {
          // Si tiene un autorizado
          bodyToSend = {
            email: this.email ? this.email : "",
            numberEmployees: this.employeesNum ? this.employeesNum : 0,
            billingAddress: {
              street: this.billingAddressStreet
                ? this.billingAddressStreet
                : "",
              number: this.billingAddressNumber
                ? this.billingAddressNumber
                : "",
              postalCode: this.billingAddressPostalCode
                ? this.billingAddressPostalCode
                : "",
              city: this.billingAddressCity ? this.billingAddressCity : "",
              province: this.billingAddressProvince
                ? this.billingAddressProvince
                : "",
            },
            deliveryAddress: {
              street: this.deliveryAddressStreet
                ? this.deliveryAddressStreet
                : "",
              number: this.deliveryAddressNumber
                ? this.deliveryAddressNumber
                : "",
              postalCode: this.deliveryAddressPostalCode
                ? this.deliveryAddressPostalCode
                : "",
              city: this.deliveryAddressCity ? this.deliveryAddressCity : "",
              province: this.deliveryAddressProvince
                ? this.deliveryAddressProvince
                : "",
            },
            // Solo incluir trustworthy y categoryRating si el usuario puede gestionarlas
            ...(this.canManageWhiteListAndCategories && {
              trustworthy: this.trustworthy,
              categoryRating: this.categoryRating,
            }),
            companyContact: [
              {
                name: this.authorized1Name ? this.authorized1Name : "",
                mobile: this.authorized1Phone ? this.authorized1Phone : "",
                email: this.authorized1Email ? this.authorized1Email : "",
                powers:
                  this.authorized1Power !== undefined
                    ? this.authorized1Power
                    : "",
                legalIdentifier: this.authorized1DNI ? this.authorized1DNI : "",
              },
            ],
          };
        }
      } else {
        // Si es un retail
        bodyToSend = {
          email: this.email ? this.email : "",
          mobile: this.mobile ? this.mobile : "",
          telephone: this.telephone ? this.telephone : "",
          // Solo incluir trustworthy y categoryRating si el usuario puede gestionarlas
          ...(this.canManageWhiteListAndCategories && {
            trustworthy: this.trustworthy,
            categoryRating: this.categoryRating,
          }),
          // Datos empresa para facturación
          companyName: this.companyName || null,
          cif: this.companyCIF || null,
          billingAddress: {
            street: this.billingAddressStreet ? this.billingAddressStreet : "",
            number: this.billingAddressNumber ? this.billingAddressNumber : "",
            postalCode: this.billingAddressPostalCode
              ? this.billingAddressPostalCode
              : "",
            city: this.billingAddressCity ? this.billingAddressCity : "",
            province: this.billingAddressProvince
              ? this.billingAddressProvince
              : "",
          },
          deliveryAddress: {
            street: this.deliveryAddressStreet
              ? this.deliveryAddressStreet
              : "",
            number: this.deliveryAddressNumber
              ? this.deliveryAddressNumber
              : "",
            postalCode: this.deliveryAddressPostalCode
              ? this.deliveryAddressPostalCode
              : "",
            city: this.deliveryAddressCity ? this.deliveryAddressCity : "",
            province: this.deliveryAddressProvince
              ? this.deliveryAddressProvince
              : "",
          },
        };
      }

      return bodyToSend;
    },

    checkSecondAuth(event) {
      if (event === true) {
        if (this.authorized2Name !== undefined) {
          this.secondAuth = true;
          return true;
        } else {
          this.secondAuth = false;
          return false;
        }
      } else {
        return false;
      }
    },
    closeModal() {
      try {
        // Intentar obtener la instancia existente del modal
        let modal = ModalBootstrap.getInstance(
          document.getElementById("clientEdit")
        );

        // Si no existe instancia, crear una nueva
        if (!modal) {
          modal = new ModalBootstrap(document.getElementById("clientEdit"));
        }

        // Cerrar el modal
        modal.hide();

        // Limpiar el backdrop manualmente si queda
        setTimeout(() => {
          const backdrop = document.querySelector(".modal-backdrop");
          if (backdrop) {
            backdrop.remove();
          }
          // Quitar la clase modal-open del body
          document.body.classList.remove("modal-open");
          // Restaurar el padding del body
          document.body.style.paddingRight = "";
        }, 300);
      } catch (error) {
        console.error("Error cerrando el modal:", error);
        // Fallback: cerrar manualmente
        this.forceCloseModal();
      }
    },

    forceCloseModal() {
      const modalElement = document.getElementById("clientEdit");
      if (modalElement) {
        modalElement.style.display = "none";
        modalElement.classList.remove("show");
        modalElement.setAttribute("aria-hidden", "true");
        modalElement.removeAttribute("aria-modal");
        modalElement.removeAttribute("role");

        // Remover backdrop
        const backdrop = document.querySelector(".modal-backdrop");
        if (backdrop) {
          backdrop.remove();
        }

        // Limpiar body
        document.body.classList.remove("modal-open");
        document.body.style.paddingRight = "";
      }
    },

    updateOriginalData() {
      // Actualizar los datos originales con los datos actuales para resetear la detección de cambios
      this.originalData.telephone = this.telephone || "";
      this.originalData.mobile = this.mobile || "";
      this.originalData.email = this.email || "";
      this.originalData.employeesNum = this.employeesNum || 0;
      this.originalData.deliveryAddressStreet =
        this.deliveryAddressStreet || "";
      this.originalData.deliveryAddressNumber =
        this.deliveryAddressNumber || "";
      this.originalData.deliveryAddressPostalCode =
        this.deliveryAddressPostalCode || "";
      this.originalData.deliveryAddressCity = this.deliveryAddressCity || "";
      this.originalData.deliveryAddressProvince =
        this.deliveryAddressProvince || "";
      this.originalData.billingAddressStreet = this.billingAddressStreet || "";
      this.originalData.billingAddressNumber = this.billingAddressNumber || "";
      this.originalData.billingAddressPostalCode =
        this.billingAddressPostalCode || "";
      this.originalData.billingAddressCity = this.billingAddressCity || "";
      this.originalData.billingAddressProvince =
        this.billingAddressProvince || "";
      this.originalData.authorized1Name = this.authorized1Name || "";
      this.originalData.authorized1Phone = this.authorized1Phone || "";
      this.originalData.authorized1Email = this.authorized1Email || "";
      this.originalData.authorized1DNI = this.authorized1DNI || "";
      this.originalData.authorized1Power = this.authorized1Power || "";
      this.originalData.authorized2Name = this.authorized2Name || "";
      this.originalData.authorized2Phone = this.authorized2Phone || "";
      this.originalData.authorized2Email = this.authorized2Email || "";
      this.originalData.authorized2DNI = this.authorized2DNI || "";
      this.originalData.authorized2Power = this.authorized2Power || "";
      // Datos empresa para facturación
      this.originalData.companyName = this.companyName || "";
      this.originalData.companyCIF = this.companyCIF || "";
    },
  },
};
</script>

<style lang="scss">
.response-message-container {
  position: fixed;
  top: 20px;
  right: 20px;
  z-index: 9999;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter,
.fade-leave {
  opacity: 0;
}

.success-message,
.error-message {
  padding: 10px 20px;
  border: 1px solid;
  border-radius: 5px;
  background-color: #fff;
  font-size: 14px;
  box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
}

.success-message {
  background-color: #d4edda;
  border-color: #c3e0b8;
}

.error-message {
  background-color: #f8d7da;
  border-color: #f5c6cb;
}
</style>
